import { withStyles } from 'vopay';
import { FunctionComponent } from 'react';
import styles from './Table.module.scss';

const cn = withStyles(styles);

type CellPadding = 'sm' | 'md';

type Column = {
  columnKey: string;
  title: string;
  align?: 'left' | 'center' | 'right';
};

type Row = {
  rowKey: string;
  [key: string]: React.ReactNode;
};

type TableProps = {
  id: string;
  columns: Column[];
  rows: Row[];
  bodyHeight?: string;
  cellPadding?: CellPadding;
  cellWidth?: string;
};

const Table: FunctionComponent<TableProps> = ({
  id,
  columns,
  rows,
  bodyHeight = '100%',
  cellPadding = 'md',
  cellWidth,
}) => {
  return (
    <div className={cn('tableContainer')} style={{ maxHeight: bodyHeight }}>
      <div className={cn('scrollWrapper')}>
        <table className={cn('table')} data-testid={`table-${id}`}>
          <thead className={cn('tableHead')}>
            <tr>
              {columns.map((col) => (
                <th
                  style={{ width: cellWidth, textAlign: col.align ?? 'left' }}
                  key={`${col.columnKey}`}
                  className={cn('tableCell', 'header', `header--${cellPadding}`)}
                >
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className={cn('tableBody')}>
            {rows.map((row) => {
              return (
                <tr key={row.rowKey}>
                  {columns.map((col) => (
                    <td
                      style={{ width: cellWidth, textAlign: col.align ?? 'left' }}
                      key={`${col.columnKey}-${row[col.title]}-${id}`}
                      className={cn('tableCell', `tableCell--${cellPadding}`, 'row')}
                    >
                      {row[col.title]}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
